import viVN from './vi_VN'

export default {
  tagsView: {
    refresh: 'Tải lại',
    close: 'Đóng',
    closeOthers: 'Đóng các tab khác',
    closeAll: 'Đóng tất cả'
  },
  ...viVN,
  ETD: 'ETD',
  ETA: 'ETA',
  i18nDemo: {
    message: 'Đây là một thông báo bằng tiếng Trung',
    btnDesc: 'Nút tiếng Trung',
    messageBtn: 'Nhấp để xem tin nhắn'
  },
  baseInfo: {
    seaport: {
      tabPort: {
        tabName: 'Cảng'
      },
      tabEdiPort: {
        tabName: 'Cảng EDI',
        shipCompany: 'Hãng tàu',
        originPortCode: 'Mã cảng gốc',
        currentPortCode: 'Mã cảng hiện tại',
        shipCompanyCheck: 'Vui lòng chọn hãng tàu!',
        originPortCodeCheck: 'Vui lòng chọn cảng!',
        currentPortCodeCheck: 'Vui lòng nhập mã cảng 5 ký tự!'
      },
      tabAmsPort: {
        tabName: 'Cảng AMS',
        amsPortMaintain: 'Bảo trì cảng AMS',
        usNo: 'US NO',
        englishName: 'Tên tiếng Anh',
        unNo: 'UN NO',
        country: 'Quốc gia',
        remark: 'Ghi chú',
        usNoCheck: 'Vui lòng nhập đúng US NO.',
        englishNameCheck: 'Tên tiếng Anh không được để trống.',
        unNoCheck: 'Vui lòng nhập đúng UN NO.',
        countryCheck: 'Quốc gia không được để trống.'
      }
    },
    city: {
      code: 'Mã',
      chineseName: 'Tên tiếng Trung',
      englishName: 'Tên tiếng Anh',
      locationCode: 'Mã thành phố',
      country: 'Quốc gia',
      addBaseCity: 'Thêm thành phố cơ bản',
      codeCheck: 'Mã không được để trống!',
      englishNameCheck: 'Tên tiếng Anh không được để trống!',
      countryCheck: 'Vui lòng chọn quốc gia!',
      lon: 'Kinh độ',
      lat: 'Vĩ độ'
    },
    overseaWarehouse: {
      warehouseCode: 'Mã kho',
      countryChineseName: 'Tên tiếng Trung',
      countryEnglishName: 'Tên tiếng Anh',
      country: 'Quốc gia',
      province: 'Bang',
      city: 'Thành phố',
      zipCode: 'Mã bưu điện',
      address: 'Địa chỉ chi tiết',
      address1: 'Địa chỉ 1',
      address2: 'Địa chỉ 2',
      address3: 'Địa chỉ 3',
      ifFba: 'Có phải kho Amazon không',
      entryRequirements: 'Yêu cầu nhập kho',
      warehouseAgeCalculationRules: 'Quy tắc tính tuổi kho',
      warehouseAgeCalculationRulesEdit: 'Quy tắc tính tuổi kho (tuần)',
      btn: {
        newFbaWarehouse: 'Thêm kho Amazon',
        newOverseaWarehouse: 'Thêm kho hải ngoại'
      },
      msg: {
        warehouseNoEmpty: 'Mã kho không được để trống',
        countryNoEmpty: 'Quốc gia không được để trống',
        cityNoEmpty: 'Thành phố không được để trống',
        zipCodeNoEmpty: 'Mã bưu điện không được để trống',
        addressNoEmpty: 'Địa chỉ chi tiết không được để trống',
        chineseNameNoEmpty: 'Tên tiếng Trung không được để trống',
        englishNameNoEmpty: 'Tên tiếng Trung không được để trống',
        warehouseAgeCalculationRulesNoEmpty: 'Quy tắc tính tuổi kho không được để trống',
        unSelectFbaWarehouse: 'Chưa chọn kho FBA',
        canNotEditFbaWarehouse: 'Không thể chỉnh sửa kho Amazon',
        duplicateAddition: '{0} đã được thêm, không thể thêm trùng lặp',
        warehouseNoLen: 'Mã kho hải ngoại không được vượt quá 16 ký tự'
      }
    },
    basicData: {
      continent: {
        code: 'Mã',
        name: 'Tên',
        codeCheck: 'Mã không được để trống!',
        nameCheck: 'Tên không được để trống!'
      },
      region: {
        code: 'Mã',
        name: 'Tên tiếng Trung',
        nameEnglish: 'Tên tiếng Anh',
        codeCheck: 'Mã không được để trống!',
        nameCheck: 'Tên tiếng Trung không được để trống!'
      },
      mscService: {
        serviceCode: 'Mã dịch vụ',
        serviceName: 'Tên dịch vụ',
        serviceCodeCheck: 'Mã dịch vụ không được để trống!',
        serviceNameCheck: 'Tên dịch vụ không được để trống!'
      },
      network: {
        code: 'Mạng lưới mã',
        name: 'Tên mạng',
        codeCheck: 'Mã mạng không được để trống!',
        nameCheck: 'Tên mạng không được để trống!'
      },
      currency: {
        serialNumber: 'Số thứ tự',
        code: 'Mã',
        name: 'Tên',
        localName: 'Tên địa phương hóa',
        interchangeCode: 'Mã trao đổi',
        isoCode: 'Mã ISO',
        defaultFractionDigits: 'Số chữ số thập phân tiền tệ',
        symbol: 'Ký hiệu',
        remarks: 'Ghi chú',
        addBaseCurrency: 'Thêm loại tiền tệ cơ bản',
        serialNumberCheck: 'Số thứ tự không được để trống!',
        codeCheck: 'Mã không được để trống!',
        nameCheck: 'Tên không được để trống!',
        interchangeCodeCheck: 'Mã trao đổi không được để trống!',
        isoCodeCheck: 'Mã ISO không được để trống!',
        defaultFractionDigitsCheck: 'Số chữ số thập phân tiền tệ không được để trống!',
        carryRule: 'Quy tắc làm tròn tiền tệ',
        rounding: 'Làm tròn',
        truncation: 'Bỏ qua'
      },
      eqType: {
        code: 'Mã',
        name: 'Tên',
        localName: 'Tên địa phương hóa',
        remark: 'Ghi chú',
        addBaseEQType: 'Thêm loại thùng cơ bản',
        codeCheck: 'Mã không được để trống!'
      },
      packing: {
        serialNumber: 'Số thứ tự',
        code: 'Mã',
        name: 'Tên',
        englishName: 'Tên tiếng Anh',
        chineseName: 'Tên tiếng Trung',
        interchangeCode: 'Mã trao đổi',
        isoCode: 'Mã ISO',
        position: 'Vị trí',
        ediCode: 'Mã EDI',
        addBasePacking: 'Thêm bao bì cơ bản',
        serialNumberCheck: 'Số thứ tự không được để trống!',
        codeCheck: 'Mã không được để trống!',
        interchangeCodeCheck: 'Mã trao đổi không được để trống!',
        isoCodeCheck: 'Mã ISO không được để trống!',
        positionCheck: 'Vị trí không được để trống!',
        userDefinedField: 'Trường tùy chỉnh'
      },
      orderFormType: {
        code: 'Mã',
        name: 'Tên',
        codeCheck: 'Mã không được để trống!',
        nameCheck: 'Tên không được để trống!'
      },
      cargoType: {
        code: 'Mã',
        chineseName: 'Tên tiếng Trung',
        englishName: 'Tên tiếng Anh',
        sea: 'Sử dụng vận tải biển',
        air: 'Sử dụng vận tải hàng không',
        fbaSea: 'Sử dụng FBA vận tải biển',
        fbaAir: 'Sử dụng FBA vận tải hàng không',
        fbaRailway: 'Sử dụng FBA vận tải đường sắt',
        codeCheck: 'Mã không được để trống!',
        chineseNameCheck: 'Tên tiếng Trung không được để trống!'
      },
      incoTerm: {
        serialNumber: 'Số thứ tự',
        code: 'Mã',
        name: 'Tên',
        localName: 'Tên địa phương hóa',
        interchangeCode: 'Mã trao đổi',
        isoCode: 'Mã ISO',
        remark: 'Ghi chú',
        addBaseIncoTerm: 'Thêm điều khoản thương mại cơ bản',
        serialNumberCheck: 'Số thứ tự không được để trống!',
        codeCheck: 'Mã không được để trống!',
        nameCheck: 'Tên không được để trống!',
        interchangeCodeCheck: 'Mã trao đổi không được để trống!',
        isoCodeCheck: 'Mã ISO không được để trống!'
      },
      shippingTerm: {
        serialNumber: 'Số thứ tự',
        code: 'Mã',
        name: 'Tên',
        localName: 'Tên địa phương hóa',
        interchangeCode: 'Mã trao đổi',
        isoCode: 'Mã ISO',
        remark: 'Ghi chú',
        addBaseShippingTerm: 'Thêm điều khoản vận chuyển cơ bản',
        serialNumberCheck: 'Số thứ tự không được để trống!',
        codeCheck: 'Mã không được để trống!',
        nameCheck: 'Tên không được để trống!',
        interchangeCodeCheck: 'Mã trao đổi không được để trống!',
        isoCodeCheck: 'Mã ISO không được để trống!',
        defaultContainerLoadType: 'Hiển thị mặc định loại đóng gói',
        defaultShow: 'Hiển thị mặc định',
        operationTypeTip: '※Sau khi cấu hình, các điều khoản vận chuyển chính/phụ của loại đóng gói tương ứng với nghiệp vụ xuất nhập khẩu đường biển sẽ được hiển thị mặc định'
      },
      paymentTerm: {
        serialNumber: 'Số thứ tự',
        code: 'Mã',
        name: 'Tên',
        localName: 'Tên địa phương hóa',
        interchangeCode: 'Mã trao đổi',
        isoCode: 'Mã ISO',
        remark: 'Ghi chú',
        addBasePaymentTerm: 'Thêm điều khoản cước phí cơ bản',
        serialNumberCheck: 'Số thứ tự không được để trống!',
        codeCheck: 'Mã không được để trống!',
        nameCheck: 'Tên không được để trống!',
        interchangeCodeCheck: 'Mã trao đổi không được để trống!',
        isoCodeCheck: 'Mã ISO không được để trống!'
      },
      tradeTerm: {
        serialNumber: 'Số thứ tự',
        code: 'Mã',
        name: 'Tên tiếng Trung',
        localName: 'Tên địa phương hóa',
        englishName: 'Tên tiếng Anh',
        interchangeCode: 'Mã trao đổi',
        isoCode: 'Mã ISO',
        remark: 'Ghi chú',
        addBaseTradeTerm: 'Thêm phương thức thương mại cơ bản',
        serialNumberCheck: 'Số thứ tự không được để trống!',
        codeCheck: 'Mã không được để trống!',
        nameCheck: 'Tên không được để trống!',
        interchangeCodeCheck: 'Mã trao đổi không được để trống!',
        isoCodeCheck: 'Mã ISO không được để trống!'
      },
      priceAirService: {
        code: 'Mã',
        chineseName: 'Tên tiếng Trung',
        englishName: 'Tên tiếng Anh',
        codeCheck: 'Mã không được để trống!',
        chineseNameCheck: 'Tên tiếng Trung không được để trống!'
      },
      portGroup: {
        portCode: 'Mã cảng',
        groupCode: 'Nhóm cảng',
        portCodeCheck: 'Mã cảng không được để trống!',
        groupCodeCheck: 'Nhóm cảng không được để trống!'
      },
      otherChargeItem: {
        chargeItemCode: 'Mã',
        chineseName: 'Tên tiếng Trung',
        measure: 'Phương thức tính phí',
        defaultApPrice: 'Đơn giá phải thu mặc định',
        remark: 'Ghi chú',
        chargeWeight: 'Tính theo trọng lượng tính phí',
        wt: 'Tính theo trọng lượng gộp',
        job: 'Tính theo số vé',
        chargeItemCodeCheck: 'Mã không được để trống!',
        chineseNameCheck: 'Tên tiếng Trung không được để trống!'
      },
      customerType: {
        typeId: 'Cấp độ',
        chineseName: 'Tên tiếng Trung',
        englishName: 'Tên tiếng Anh',
        typeIdCheck: 'Cấp độ không được để trống!',
        chineseNameCheck: 'Tên tiếng Trung không được để trống!',
        englishNameCheck: 'Tên tiếng Anh không được để trống!'
      },
      appraisalCategory: {
        serialNumber: 'Số thứ tự',
        serialNumberCheck: 'Số thứ tự không được để trống',
        code: 'Mã',
        codeCheck: 'Mã không được để trống',
        chineseName: 'Tên tiếng Trung',
        englishName: 'Tên tiếng Anh',
        chineseNameCheck: 'Tên tiếng Trung không được để trống!',
        englishNameCheck: 'Tên tiếng Anh không được để trống!'
      },
      blMode: {
        serialNumber: 'Số thứ tự',
        code: 'Mã',
        name: 'Tên',
        localName: 'Tên địa phương hóa',
        interchangeCode: 'Mã trao đổi',
        isoCode: 'Mã ISO',
        blType: 'Loại vận đơn',
        remark: 'Ghi chú',
        addBaseBlMode: 'Thêm phương thức vận đơn',
        serialNumberCheck: 'Số thứ tự không được để trống!',
        codeCheck: 'Mã không được để trống!',
        nameCheck: 'Tên không được để trống!',
        interchangeCodeCheck: 'Mã trao đổi không được để trống!',
        isoCodeCheck: 'Mã ISO không được để trống!'
      },
      cutomJobType: {
        serialNumber: 'Số thứ tự',
        code: 'Mã',
        name: 'Tên',
        localName: 'Tên địa phương',
        englishName: 'Tên tiếng Anh',
        type: 'Loại hình nghiệp vụ',
        remarks: 'Ghi chú',
        containerLoadType: 'Mô hình nghiệp vụ',
        addBaseBlMode: 'Thêm phương thức thương mại cơ bản',
        serialNumberCheck: 'Số thứ tự không được để trống!',
        codeCheck: 'Mã không được để trống!',
        nameCheck: 'Tên không được để trống!',
        englishNameCheck: 'Tên tiếng Anh không được để trống!',
        typeCheck: 'Loại hình kinh doanh không được để trống!',
        interchangeCode: 'Mã trao đổi',
        codeTips1: '*Định dạng mã: chữ cái và số, giới hạn 4 ký tự.',
        codeTips2: 'Độ dài mã vượt quá giới hạn, vui lòng nhập lại!',
        codeTips3: 'Định dạng mã không chính xác, vui lòng nhập lại!',
        codeTips4: '*Định dạng mã: chữ cái, số và kết hợp, giới hạn 10 ký tự.'
      },
      chargeUnit: {
        codeCheck: 'Mã không được để trống!',
        chineseNameCheck: 'Tên tiếng Trung không được để trống!',
        englishNameCheck: 'Tên tiếng Anh không được để trống!',
        chargeUnitAndUnitCheck: 'Ít nhất chọn một đơn vị tính phí hoặc đơn vị để hiển thị, vui lòng chọn!',
        seaFreightAndAirFreightCheck: 'Ít nhất chọn một trong vận tải biển hoặc hàng không để hiển thị, vui lòng chọn!',
        businessTypeCheck: 'Ít nhất chọn một trong vận tải biển, hàng không, FBA biển, FBA hàng không, FBA đường sắt để hiển thị, vui lòng chọn!',
        fbaSeaAndAirAndRailwayCheck: 'Ít nhất chọn một trong vận tải biển, hàng không hoặc đường sắt để hiển thị, vui lòng chọn!'
      },
      dangerousGoods: {
        codeCheck: 'Vui lòng điền số Liên Hợp Quốc'
      },
      cargoInformation: {
        codeCheck: 'Mã không được để trống!',
        chineseNameCheck: 'Tên tiếng Trung không được để trống!',
        englishNameCheck: 'Tên tiếng Anh không được để trống!'
      },
      propulsionType: {
        codeCheck: 'Tên không được để trống!'
      },
      baseCustomsDeclarationType: {
        code: 'Mã',
        name: 'Tên tiếng Trung',
        englishName: 'Tên tiếng Anh',
        codeCheck: 'Mã không được để trống!',
        nameCheck: 'Tên tiếng Trung không được để trống!',
        englishNameCheck: 'Tên tiếng Anh không được để trống!',
        codeTooLong: 'Cột [Mã] dữ liệu quá dài',
        nameTooLong: 'Cột [Tên tiếng Trung] dữ liệu quá dài',
        englishNameTooLong: 'Cột [Tên tiếng Anh] dữ liệu quá dài',
        addBaseCustomsDeclarationType: 'Thêm loại hình khai báo hải quan',
        isPlatform: 'Có phải dữ liệu nền tảng?',
        PlatformTip: 'Dữ liệu mới thêm từ nền tảng không thể chỉnh sửa!'
      },
      gpExplainTitle: {
        codeCheck: 'Mã không được để trống!',
        chineseNameCheck: 'Tên tiếng Trung không được để trống!',
        englishNameCheck: 'Tên tiếng Anh không được để trống!'
      }
    },
    airport: {
      addBasePort: 'Thêm cảng cơ bản',
      serialNumber: 'Số thứ tự',
      code: 'Mã',
      chineseName: 'Tên tiếng Trung',
      englishName: 'Tên tiếng Anh',
      interchangeCode: 'Mã trao đổi',
      isoCode: 'Mã ISO',
      countryCode: 'Quốc gia',
      region: 'Khu vực',
      requirement: 'Yêu cầu cảng',
      whetherToAdd: 'Đã thêm chưa?',
      portAdd: 'Thêm cảng',
      portEdit: 'Chỉnh sửa cảng',
      cityName: 'Tên thành phố',
      cityCode: 'Mã thành phố',
      codeCheck: 'Vui lòng nhập mã cảng chính xác',
      interchangeCodeCheck: 'Mã trao đổi không được để trống',
      isoCodeCheck: 'Mã ISO không được để trống',
      englishNameCheck: 'Tên tiếng Anh không được để trống'
    },
    operation: {
      operationType: 'Loại yêu cầu thao tác',
      lobType: 'Loại hình nghiệp vụ',
      code: 'Mã',
      lob: 'Loại hình nghiệp vụ',
      operationRequirementType: 'Loại thao tác',
      contentDescription: 'Mã/mô tả nội dung',
      operationMaintain: 'Bảo trì yêu cầu thao tác',
      remark: 'Ghi chú',
      enterContentDescription: 'Vui lòng nhập mã hoặc mô tả nội dung'
    },
    customsCommodityCode: {
      code: 'Mã hàng hóa',
      commodityName: 'Tên sản phẩm',
      mfnRate: 'Thuế quan tối huệ quốc',
      generalRate: 'Thuế suất thông thường',
      vat: 'Thuế giá trị gia tăng',
      legalUnit: 'Đơn vị pháp định',
      mscCommodity: 'Tên tiếng Anh (MSC)',
      secondUnit: 'Đơn vị thứ hai',
      superviseMode: 'Phương thức giám sát',
      customsCommodityCodeMaintain: 'Bảo trì mã hàng hóa hải quan',
      countryCode: 'Mã quốc gia',
      countryCodeCheck: '国家代码不能为空. ',
      codeCheck: '商品编码不能为空. ',
      commodityNameCheck: 'Tên sản phẩm không được để trống.'
    },
    usCommodityCode: {
      systemCode: 'Mã hệ thống',
      tradeName: 'Tên hàng hóa',
      productDescription: 'Mô tả hàng hóa',
      descriptionCode: 'Mã mô tả',
      customsTariff: 'Thuế suất hải quan',
      additionalTaxRate056: 'Thuế suất bổ sung 056',
      including499AdditionalTaxRate: 'Thuế suất bổ sung bao gồm 499',
      including501AdditionalTaxRate: 'Thuế suất bổ sung bao gồm 501',
      chinaAdditionalTaxRate: 'Thuế suất bổ sung Trung Quốc',
      chinaSurtaxTariff: 'Quy tắc thuế bổ sung Trung Quốc',
      chinaSurtaxClause: 'Điều khoản thuế bổ sung Trung Quốc',
      enable: 'Kích hoạt',
      disable: 'Vô hiệu hóa',
      chinaHongKongSurtaxTariff: 'Quy tắc thuế bổ sung Hồng Kông Trung Quốc',
      remark: 'Ghi chú'
    },
    country: {
      serialNumber: 'Số thứ tự',
      code: 'Mã',
      englishName: 'Tên tiếng Anh',
      chineseName: 'Tên tiếng Trung',
      continent: 'Châu lục',
      interchangeCode: 'Mã trao đổi',
      isoCode: 'Mã ISO',
      countryMaintain: 'Bảo trì quốc gia'
    },
    rateManagement: {
      copyRate: 'Sao chép tỷ giá',
      originalCurrency: 'Tiền tệ gốc',
      benchmarkCurrency: 'Tiền tệ chuẩn',
      rate: 'Tỷ giá hối đoái',
      effectiveMonth: 'Tháng hiệu lực',
      currentMonth: 'Tháng hiện tại',
      baseCuurency: 'Tiền tệ chuẩn',
      currency: 'Tiền tệ gốc',
      month: 'Tháng hiệu lực',
      rateMaintain: 'Bảo trì tỷ giá',
      currencyCheck: 'Vui lòng nhập tiền tệ gốc!',
      rateCheck: 'Vui lòng nhập tỷ giá!',
      rateIsTooLong: 'Tỷ giá quá lớn, vui lòng điều chỉnh',
      repeatCheck: 'Cấu hình trùng lặp, vui lòng sửa lại!',
      repeatCheck2: 'Tỷ giá chuyển đổi {0} sang {1} bị trùng lặp, vui lòng sửa lại!',
      copyRateMaintain: 'Sao chép tỷ giá của tháng chỉ định',
      copyCurrentMonthCheck: 'Không thể sao chép dữ liệu tháng hiện tại, vui lòng chọn tháng khác!',
      copyRowDataCheck: 'Không có dữ liệu tháng này!',
      copyRateSuccess: 'Sao chép tỷ giá thành công',
      notFoundRate: 'Không tìm thấy tỷ giá cho tiền tệ {0}, vui lòng cập nhật tỷ giá liên quan!',
      setRateCacheRange: 'Thiết lập thời gian lưu cache tỷ giá',
      setRateCacheRangeNote: 'Thiết lập phạm vi tháng lưu cache tỷ giá từ 18-36 tháng',
      setRateCacheRangePrefix: 'Tháng lưu cache',
      setRateCacheRangeSuffix: 'tháng'
    },
    // 合作伙伴
    partner: {
      companyName: 'Đối tác',
      companyType: 'Loại khách hàng',
      customerTypeId: 'Cấp độ khách hàng',
      remarks: 'Ghi chú bổ sung',
      approvedState: 'Trạng thái phê duyệt',
      volume: 'Số phiếu',
      cmpIdx: 'Mã số',
      shortName: 'Tên viết tắt',
      cnShortName: 'Mã',
      region: 'Quốc gia',
      area: 'Khu vực',
      chineseName: 'Tên tiếng Trung',
      englishName: 'Tên tiếng Anh',
      contractStatus: 'Trạng thái ký kết',
      branchId: 'Chi nhánh trực thuộc',
      approvedBy: 'Người phê duyệt',
      dateApproved: 'Ngày phê duyệt',
      createBy: 'Người tạo',
      dateType: 'Loại ngày',
      controlSetting: 'Loại ngày thiết lập tín dụng',
      creditDateType: 'Phương thức thanh toán',
      blacklist: 'Danh sách đen',
      cargoSource: 'Loại nhận hàng',
      receivableDeposit: 'Loại thu chi',
      accountingPeriod: 'Kỳ hạn thanh toán',
      quota: 'Hạn mức',
      creditQuota: 'Hạn mức tín dụng',
      creditCurrency: 'Loại tiền tín dụng',
      payment: 'Thanh toán',
      supplierDirector: 'Người phụ trách nhà cung cấp',
      dateCreated: 'Ngày tạo',
      modifiedBy: 'Người sửa đổi',
      dateModified: 'Ngày sửa đổi',
      isActive: 'Có hiệu lực không',
      relateTenantUuid: 'Khách hàng thương mại điện tử',
      sales: 'Bán hàng',
      freightVolume30: '30 ngày (phiếu)',
      freightVolume60: '60 ngày (phiếu)',
      freightVolume90: '90 ngày (phiếu)',
      freightVolumeGt90: 'Trên 90 ngày (phiếu)',
      // 基础信息
      basicInfo: {
        title: 'Thông tin cơ bản',
        relatedBusinessType: 'Loại nghiệp vụ liên quan',
        scac: 'SCAC',
        province: 'Tỉnh',
        city: 'Thành phố',
        district: 'Quận/Huyện'
      }
    },
    // 收发通地址
    mailingAddress: {
      office: 'Chi nhánh công ty',
      lobType: 'Loại hình nghiệp vụ',
      partner: 'Khách hàng/Đại lý nước ngoài',
      podName: 'Tên cảng đến',
      shipperCode: 'Mã người gửi hàng',
      shipperInfo: 'Thông tin người gửi hàng',
      consigneeCode: 'Mã người nhận hàng',
      consigneeInfo: 'Thông tin người nhận hàng',
      notifyCode: 'Mã người thông báo',
      notifyInfo: 'Thông tin người thông báo',
      shipperName: 'Tên người gửi hàng',
      consigneeName: 'Tên người nhận hàng',
      notifyName: 'Tên người thông báo',
      partner1: 'Khách hàng',
      pod1: 'Cảng đến',
      formatManifestInfo: 'Thông tin manifest định dạng',
      shipper: 'Người gửi hàng',
      shipperEnterpriseCode: 'Mã doanh nghiệp người gửi hàng',
      shortCode: 'Viết tắt mã',
      enterpriseCode: 'Mã doanh nghiệp',
      shipperEnterpriseName: 'Tên doanh nghiệp người gửi hàng',
      shipperAddress: 'Địa chỉ chi tiết người gửi hàng',
      cityName: 'Tên thành phố',
      provinceCode: 'Mã tỉnh',
      provinceName: 'Tên tỉnh',
      zipCode: 'Mã bưu điện',
      countryCode: 'Mã quốc gia',
      aeoEnterpriseCode: 'Số doanh nghiệp AEO',
      syncFormatInfoToOrder: 'Đồng bộ thông tin định dạng vào đơn hàng',
      consignee: 'Người nhận hàng',
      instructBill: 'Vận đơn theo lệnh',
      consigneeEnterpriseCode: 'Mã doanh nghiệp người nhận hàng',
      consigneeEnterpriseName: 'Tên doanh nghiệp người nhận hàng',
      consigneeAddress: 'Địa chỉ chi tiết người nhận hàng',
      consigneeSpecificContactsName: 'Tên người liên hệ cụ thể',
      consigneeSpecificContacts: 'Số điện thoại người liên hệ cụ thể',
      notify: 'Người thông báo',
      notifyEnterpriseCode: 'Mã doanh nghiệp người thông báo',
      notifyEnterpriseName: 'Tên doanh nghiệp người thông báo',
      notifyAddress: 'Địa chỉ chi tiết người thông báo',
      shipperPhoneNumber: 'Số điện thoại người gửi hàng',
      shipperEmail: 'Địa chỉ email người gửi hàng',
      shipperFax: 'Số telex người gửi hàng',
      consigneePhoneNumber: 'Số điện thoại người nhận hàng',
      consigneeEmail: 'Địa chỉ email người nhận hàng',
      consigneeFax: 'Số telex người nhận hàng',
      consigneeSpecificPhoneNumber: 'Số điện thoại người liên hệ cụ thể',
      consigneeSpecificEmail: 'Địa chỉ email người liên hệ cụ thể',
      consigneeSpecificFax: 'Số telex người liên hệ cụ thể',
      notifyPhoneNumber: 'Số điện thoại người thông báo',
      notifyEmail: 'Địa chỉ email người thông báo',
      notifyFax: 'Số telex người thông báo',
      addMailingAddress: 'Thêm địa chỉ gửi/nhận/thông báo',
      editMailingAddress: 'Sửa địa chỉ gửi/nhận/thông báo',
      validLobMsg: 'Vui lòng chọn mã nghiệp vụ.',
      validInstructBill: 'Trong chế độ vận đơn chỉ định người nhận, mã doanh nghiệp và thông tin liên hệ người thông báo đều bắt buộc.',
      fbaWarehouseCode: 'Mã kho Amazon',
      contactName: 'Tên người liên hệ',
      province: 'Tỉnh/Bang',
      addr1: 'Địa chỉ 1',
      addr2: 'Địa chỉ 2',
      addr3: 'Địa chỉ 3',
      eoriNo: 'EORI/Mã doanh nghiệp',
      taxNo: 'Mã số thuế',
      ManifestFormatShipper: 'Người gửi hàng được định dạng trong manifest',
      TheManifestFormatConsignee: 'Người nhận hàng được định dạng trong manifest',
      ManifestFormatNotifier: 'Người thông báo được định dạng trong manifest'
    }
  },
  sysManage: { // 系统管理
    baseConfig: { // 基本配置
      triggerTypeManagement: { // 触发类型管理
        addTriggerType: 'Thêm loại kích hoạt',
        editTriggerType: 'Sửa loại kích hoạt',
        lookTriggerType: 'Xem loại kích hoạt',
        validFieldNameMsg: 'Vui lòng nhập tên trường.',
        validFieldEnameMsg: 'Vui lòng nhập tên tiếng Anh của trường.',
        triggerType: 'Loại cập nhật',
        fieldCheckType: 'Phương thức kiểm tra trường',
        entityCode: 'Mã thực thể',
        entityName: 'Tên thực thể',
        entityEname: 'Tên tiếng Anh thực thể',
        fieldCode: 'Mã trường',
        fieldName: 'Tên trường',
        fieldEname: 'Tên tiếng Anh trường',
        fieldCheckValue: 'Giá trị kiểm tra trường',
        innerDateState: 'Trạng thái bắt nguồn từ dữ liệu nội bộ',
        outerDateState: 'Trạng thái bắt nguồn từ dữ liệu bên ngoài',
        applySopNode: 'Áp dụng nút SOP',
        remark: 'Ghi chú'
      },
      routeWareHouseConfiguration: { // 航线与仓库配置
        addRouteWareHouseMapping: 'Thêm cấu hình tuyến đường và kho hàng',
        editRouteWareHouseMapping: 'Chỉnh sửa cấu hình tuyến đường và kho hàng',
        validRegionCodeMsg: 'Vui lòng nhập mã tuyến đường.',
        validWarehouseMsg: 'Vui lòng chọn kho hàng.',
        regionCode: 'Mã tuyến đường',
        warehouse: 'Kho hàng',
        remark: 'Ghi chú'
      },
      singleOnlineSetting: { // 海运在线对单设置
        branchId: 'Chi nhánh công ty',
        fieldCode: 'Mã trường',
        fieldName: 'Tên trường',
        fclEdit: 'Cho phép chỉnh sửa (nguyên container)',
        lclEdit: 'Cho phép chỉnh sửa (hàng lẻ)'
      }
    }
  },
  sysMonitor: { // 系统监控
    sopSendLog: {
      orderNo: 'Số serial',
      relationId: 'Mã nghiệp vụ',
      dateCreated: 'Thời gian đẩy',
      type: 'Loại',
      pushNode: 'Nút đẩy',
      pushingChannel: 'Kênh đẩy',
      pushingResult: 'Kết quả đẩy',
      receivingUser: 'Người nhận',
      receivingTxt: 'Mô tả nội dung',
      modifyDate: 'Thời gian thay đổi SOP',
      file: 'Tệp'
    }
  },
  common: {
    defaultPlaceholder: 'Vui lòng nhập từ khóa',
    BeginDate: 'Ngày bắt đầu',
    EndDate: 'Ngày kết thúc',
    pagePer: 'Dòng/trang',
    pleaseChoose: 'Vui lòng chọn',
    confirm: 'Xác nhận',
    reset: 'Đặt lại',
    cancel: 'Hủy',
    tips: {
      fuzzySearch: 'Vui lòng nhập mã, tên để tìm kiếm mờ',
      fuzzyCodeSearch: 'Vui lòng nhập mã để tìm kiếm mờ',
      fuzzyModelSearch: 'Vui lòng nhập kiểu máy để tìm kiếm mờ',
      overseaWarehouseFuzzySearch: 'Vui lòng nhập mã kho nước ngoài để tìm kiếm mờ',
      fuzzySearchForJudgment: 'Vui lòng nhập số thứ tự, lý do xác định trách nhiệm để tìm kiếm mờ',
      fuzzySearchForCustomEqType: 'Vui lòng nhập kích thước, loại thùng để tìm kiếm mờ',
      hasOneAtleast: 'Vui lòng chọn ít nhất một bản ghi',
      hasOneAtleastAudit: 'Vui lòng chọn ít nhất một bản ghi đã được kiểm duyệt',
      hasOneOnly: 'Vui lòng chỉ chọn một bản ghi',
      cannotDeleteBranch: 'Không thể xóa chi nhánh tạo bởi phương án phí!',
      saveSuccess: 'Lưu thành công!',
      prompt: 'Nhắc nhở',
      systemPrompt: 'Thông báo hệ thống',
      confirmDelete: 'Xác nhận xóa bản ghi này?',
      confirmCheck: 'Xác nhận kiểm duyệt bản ghi?',
      confirmCancelCheck: 'Xác nhận hủy kiểm duyệt bản ghi?',
      confirm: 'Xác nhận',
      deleteSuccess: 'Xóa thành công!',
      editSuccess: 'Chỉnh sửa thành công!',
      deleteFail: 'Xóa thất bại!',
      cancelDelete: 'Hủy xóa!',
      yes: 'Có',
      no: 'Không',
      repeatedlyTip: 'Thêm trùng lặp',
      pleaseChoose: 'Vui lòng chọn',
      isAdded: 'Đã thêm chưa?',
      resetSuccess: 'Đặt lại thành công!',
      warning: 'Cảnh báo',
      branchSame: 'Dữ liệu đang thao tác không thuộc chi nhánh hiện tại hoặc chi nhánh cấp trên!'
    },
    btn: {
      refresh: 'Tải lại',
      query: 'Truy vấn',
      look: 'Xem',
      new: 'Thêm mới',
      add: 'Thêm',
      edit: 'Chỉnh sửa',
      editAgain: 'Chỉnh sửa lại',
      delete: 'Xóa',
      exportExcel: 'Xuất Excel',
      downLoadTemplate: 'Tải mẫu',
      save: 'Lưu',
      cancel: 'Hủy',
      ok: 'Xác nhận',
      confirm: 'Xác nhận',
      back: 'Quay lại',
      audit: 'Duyệt',
      reject: 'Từ chối',
      reset: 'Đặt lại',
      close: 'Đóng',
      yes: 'Có',
      no: 'Không',
      next: 'Bước tiếp theo',
      confirmUpdate: 'Xác nhận thay đổi',
      enable: 'Bật',
      disable: 'Tắt'
    },
    createBy: 'Người tạo',
    dateCreated: 'Thời gian tạo',
    modifiedBy: 'Người thay đổi',
    dateModified: 'Thời gian thay đổi'
  },
  // 常量
  constant: {
    all: 'Tất cả',
    yes: 'Có',
    no: 'Không',
    greaterThan: 'Lớn hơn',
    lessThan: 'Nhỏ hơn',
    equal: 'Bằng',
    email: 'Email',
    note: 'Tin nhắn',
    sop: { // sop 常量

      JOB_NO: 'Mã nghiệp vụ',
      CUSTOMER_ID: 'Đơn vị ủy quyền',
      CUSTOMER_ID_CN: 'Đơn vị ủy thác (tiếng Trung)',
      CUSTOMER_ID_US: 'Đơn vị ủy thác (tiếng Anh)',
      CARRIER_CN: 'Công ty tàu (tiếng Trung)',
      CARRIER_US: 'Công ty tàu (tiếng Anh)',
      CARRIER_CODE: 'Công ty tàu (mã)',
      CARRIER_SHORT_NAME: 'Công ty tàu (tên viết tắt)',
      DESTINATION_AGENT: 'Đại lý cảng đích',
      DESTINATION_AGENT_SHORT_NAME: 'Đại lý cảng đích (tên viết tắt)',
      DESIGNATION_AGENT: 'Đại lý hàng hóa chỉ định',
      BARGE_POL: 'Cảng khởi hành sà lan',
      LOADING_PORT_CODE: 'Cảng khởi hành',
      LOADING_PORT_CODE3: 'Mã cảng khởi hành',
      DESTINATION_PORT_CODE: 'Cảng đến',
      DESTINATION_PORT_CODE2: 'Mã cảng đích',
      VESSEL: 'Tên tàu',
      VOYAGE: 'Chuyến đi',
      BRANCH_VESSEL: 'Tên sà lan nhánh',
      BRANCH_VOYAGE: 'Chuyến đi sà lan nhánh',
      WAREHOUSE_NO: 'Số vào kho',
      SO_NO: 'S/O NO.',
      MBL: 'MB/L NO',
      HBL_NO: 'HB/L NO',
      ETD: 'ETD',
      ETA: 'ETA',
      ATD: 'ATD',
      ATA: 'ATA',
      CUSTOMS_DATE: 'Ngày thao tác',
      CONSIGNEE_CODE: 'Người nhận hàng',
      CUSTOMER_REF_NO: 'Số tham chiếu nghiệp vụ',
      USER_DEFINED_FIELD1: 'Trường tùy chỉnh 1',
      USER_DEFINED_FIELD2: 'Trường tùy chỉnh 2',
      USER_DEFINED_FIELD3: 'Trường tùy chỉnh 3',
      USER_DEFINED_FIELD4: 'Trường tùy chỉnh 4',
      ESTIMATED_SHIPPING_DATE: 'Ngày tàu dự kiến',
      CSR: 'Dịch vụ khách hàng',
      CSR_PHONE: 'Số điện thoại dịch vụ khách hàng',
      CSR_EMAIL: 'Email dịch vụ khách hàng',
      OVERSEA_OP_EMAIL: 'Email dịch vụ khách hàng hải ngoại',
      DC_EMAIL: 'Email chứng từ',
      PORT_DISTRICT: 'Khu cảng',
      TERMINAL_OPENDATE: 'Ngày mở cảng',
      TERMINAL_CUTOFF: 'Ngày đóng cảng',
      REAL_ARRIVALS_DATE: 'Ngày vào cảng thực tế',
      BERTH_PLAN_DATE: 'Ngày cập bến theo kế hoạch',
      ACTUAL_BERTH_PLAN_DATE: 'Ngày cập bến thực tế',
      UN_BERTH_PLAN_DATE: 'Ngày rời bến theo kế hoạch',
      ACTUAL_UN_BERTH_PLAN_DATE: 'Ngày rời bến thực tế',
      BERTH_PLAN_PLACE: 'Vị trí cập bến theo kế hoạch',
      ACTUAL_BERTH_PLAN_PLACE: 'Vị trí cập bến thực tế',
      OP_EMAIL: 'Email thao tác',
      DESTINATION_AGENT_EMAIL: 'Email liên hệ mặc định đại lý cảng đích',
      SINGLE_ADDRESS: 'Địa chỉ đối chiếu chứng từ',
      CUTOFF_TIME: 'Ngày đóng chứng từ',
      EstimatedArrivalTime: 'Thời gian dự kiến đến cảng',
      actualArrivalTime: 'Thời gian đến cảng thực tế',
      PortDischargeTime: 'Thời gian dỡ hàng',
      ActualLiftingDate: 'Thời gian nhận hàng thực tế',
      ActualReturnTime: 'Thời gian trả container rỗng thực tế',
      MBLTransportationClause: 'Điều khoản vận chuyển vận đơn chính',
      HBLTransportationClause: 'Điều khoản vận chuyển vận đơn phụ',
      MasterBLFreightTerm: 'Điều khoản cước phí vận đơn chính',
      HBLFreightClause: 'Điều khoản cước phí vận đơn phụ',
      MORE_DOOR_QUANTITY: 'Số kiện tại nhiều điểm giao nhận',
      ROUGH_WEIGHT: 'Trọng lượng cả bì tại nhiều điểm giao nhận',
      MORE_DOOR_VOLUME: 'Khối lượng tại nhiều điểm giao nhận',
      PACKAGING_TYPE: 'Loại bao bì',
      SHIPPER_CODE: 'HBL Shipper Code',
      BUSINESS_MODEL: 'Mô hình nghiệp vụ',
      TICKET_RECEIPT: 'Vận đơn chính/phụ',
      NO_LISTING: 'Danh sách số container tại điểm giao nhận',
      ESTIMATED_DELIVERY_DATE: 'Ngày giao hàng dự kiến tại điểm',
      UNLOADING_WAY: 'Phương thức dỡ hàng tại điểm',
      PO: 'PO',
      CNEE_CODE: 'HBL CNEE Code',
      ADDRESS: 'Địa chỉ điểm giao nhận',
      BASIC_NUMBER: 'Thẻ cơ bản - Số kiện',
      BASIC_ROUGH_WEIGHT: 'Thẻ cơ bản - Trọng lượng cả bì',
      BASIC_VOLUME: 'Thẻ cơ bản - Khối lượng',
      DELIVER_DATE: 'Ngày nhận hàng',
      ARRIVE_STORAGE_DATE: 'Ngày hàng đến kho',
      TRANS_DATE: 'Ngày đổi vận đơn',
      CUSTOMER_REF_NO2: 'Số tham chiếu khách hàng',
      LOADING_PORT_CODE2: 'Cảng xếp hàng',
      CARRIER_ID: 'Hãng hàng không',
      CARRIER_ID_CN: 'Hãng hàng không (tiếng Trung)',
      CARRIER_ID_US: 'Hãng hàng không (tiếng Anh)',
      VOYAGE_FLIGHT: 'Chuyến bay',
      ETD2: 'Ngày khởi hành',
      ETA2: 'Ngày đến cảng',
      WAREHOUSE_NO2: 'Số vào kho',
      QUANTITY: 'Số kiện (nhập kho)',
      WEIGHT: 'Trọng lượng cả bì (nhập kho)',
      VOLUME: 'Khối lượng (nhập kho)',
      TRANSPORTATION_COMPANY: 'Công ty vận tải',
      CONTAINER_NO: 'Số container',
      SEAL_NO: 'Số niêm phong',
      EMPTY_CABINET_WEIGHT: 'Trọng lượng container rỗng',
      ESTIMATED_DATE: 'Ngày đóng hàng dự kiến (đến nhà máy)',
      ACTUAL_PACKING: 'Ngày đóng hàng thực tế (đến nhà máy)',
      CONTAINER_DESC: 'Mô tả số lượng container',
      EXPECTED_ARRIVAL_DATE: 'Ngày hàng đến dự kiến',
      ACTUAL_ARRIVAL_DATE: 'Ngày hàng đến thực tế',
      CUSTOMER_DOOR_POINT: 'Điểm giao nhận khách hàng',
      CUSTOMER_PORTAL_ADDRESS: 'Điểm giao nhận khách hàng',
      DESTINATION_GATE_POINT: 'Điểm giao nhận đích',
      ADDRESS_OF_DESTINATION_GATE_POINT: 'Địa chỉ điểm giao nhận đích',
      WAREHOUSE_SUPPLIER: 'Nhà cung cấp kho bãi',
      WAREHOUSE_NAME: 'Tên kho',
      DOWNLOAD_URL: 'Liên kết tải xuống tờ khai sơ bộ',
      MBL2: 'MAWB NO',
      HAWB: 'HAWB NO',
      DISCHARGING_PORT: 'Cảng dỡ hàng',
      DISCHARGING_PORT2: 'Mã cảng dỡ hàng',
      WAREHOUSE_DATA: 'Dữ liệu nhập kho',
      STATUS_UPDATE_TIME: 'Thời gian thay đổi trạng thái',
      QUANTITY_CONTRACT: 'Số lượng kiện ủy thác',
      WEIGHT_CONTRACT: 'Trọng lượng cả bì ủy thác',
      CUBAGE_CONTRACT: 'Thể tích ủy thác',
      TRUST_FROM_JOB: 'Số liên quan ủy thác',
      RELATED_JOB: 'Số liên quan giao dịch',
      BASIC_SHIPPER_CODE: 'CODE người gửi cơ bản',
      BASIC_CONSIGNEE_CODE: 'CODE người nhận cơ bản',
      INCOTERMS: 'Điều khoản thương mại',
      CHARGE_WEIGHT: 'Trọng lượng tính cước',
      PACKAGE: 'Đóng gói',
      REMARK: 'Ghi chú',
      POD: 'Địa điểm giao hàng',
      LOADING_PORT_CODE4: 'Mã cảng xếp hàng',

      MBLNO: 'Số vận đơn chính',
      CONTACT: 'Người liên hệ',
      AIR_LINE: 'Tuyến đường',
      TRANSPORT_TYPE: 'Loại hình vận chuyển',
      DEPARTURE_STATION: 'Ga xuất phát',
      DEPARTURE_STATION_CODE: 'Mã ga xuất phát',
      DESTINATION_STATION: 'Ga đích',
      DESTINATION_STATION_CODE: 'Mã ga đích',
      TRANSIT_STATION: 'Ga quá cảnh',
      TRANSIT_STATION_CODE: 'Mã ga quá cảnh',
      PAYMENT_METHOD: 'Phương thức thanh toán',
      TRACK_NO: 'Số vận đơn',
      SHUTTLE: 'Xe tuyến',
      TRAIN_NO: 'Số chuyến',
      QUANTITY_ACTUAL: 'Số lượng kiện thực tế',
      WEIGHT_ACTUAL: 'Trọng lượng cả bì thực tế',
      CUBAGE_ACTUAL: 'Thể tích thực tế',
      CARGO_CHINESE_NAME_BASE: 'Tên hàng bằng tiếng Trung (cơ bản)',
      CARGO_ENGLISH_NAME_BASE: 'Tên hàng bằng tiếng Anh (cơ bản)',
      CARGO_ENGLISH_NAME: 'Tên hàng bằng tiếng Anh',
      SALES: 'Bán hàng',
      SALES_EMAIL: 'Email bán hàng',
      // 新增毛体重
      ACTUAL_PIECE: 'Số lượng kiện (thực tế)',
      ACTUAL_WEIGHT: 'Trọng lượng cả bì (thực tế)',
      ACTUAL_VOLUME: 'Thể tích (thực tế)',
      CUSTOMER_SERVICE: 'Dịch vụ khách hàng',
      DOCUMENT: 'Chứng từ',
      ROUTE_MANAGER: 'Người phụ trách tuyến đường',
      OVERSEAS_CUSTOMER_SERVICE: 'Dịch vụ khách hàng hải ngoại',
      ROUTE_MANAGER_EMAIL: 'Email người phụ trách tuyến đường',
      INTEGRATION_TYPE: 'Loại hình ghép hàng',
      ROUTE_LEADER: 'Người phụ trách lộ trình',
      ROUTE_LEADER_EMAIL: 'Email người phụ trách lộ trình',
      OPERATE: 'Thao tác',
      MBLCMR: 'Số vận đơn chính',
      DISCHARGING_PLACE: 'Địa điểm gửi hàng',
      LOADING_PORT: 'Nơi xuất phát',
      DESTINATION_PORT: 'Điểm đến',
      DOMESTIC_PLATE_NUMBER: 'Biển số xe nội địa',
      KH_PLATE_NUMBER: 'Biển số xe tải',
      KH_TRAILER_NUMBER: 'Số rơ-moóc xe tải',
      VOYAGE_FLIGHT_NO: 'Số chuyến bay',
      BOOKING_DATE: 'Ngày đặt chỗ',
      ACTUAL_ENTRY_TIME: 'Thời gian vào sân bay thực tế',
      ACTUAL_LOADING_TIME: 'Thời gian xếp hàng thực tế',
      ESTIMATED_DEPARTURE_TIME: 'Thời gian cất cánh dự kiến',
      ACTUAL_DEPARTURE_TIME: 'Thời gian cất cánh thực tế',
      ESTIMATED_ARRIVAL_TIME: 'Thời gian đến dự kiến',
      ACTUAL_ARRIVAL_TIME: 'Thời gian đến thực tế',
      ACTUAL_RECEIVING_TIME: 'Thời gian nhận đơn thực tế',
      ACTUAL_UNLOADING_TIME: 'Thời gian dỡ hàng thực tế',
      ACTUAL_ARRIVAL_NOTIFICATION_TIME: 'Thời gian thông báo hàng đến thực tế',
      ACTUAL_PICKUP_TIME: 'Thời gian nhận hàng thực tế',
      SECOND_FLIGHT: 'Số chuyến bay (thông tin chặng thứ hai)',
      ESTIMATED_TRANSFER_ARRIVAL_TIME: 'Thời gian đến trung chuyển dự kiến (thông tin chặng thứ hai)',
      TRANSFER_ARRIVAL_TIME: 'Thời gian đến trung chuyển (thông tin chặng thứ hai)',
      ESTIMATED_TRANSFER_DEPARTURE_TIME: 'Thời gian cất cánh trung chuyển dự kiến (thông tin chặng thứ hai)',
      TRANSFER_DEPARTURE_TIME: 'Thời gian cất cánh trung chuyển (thông tin chặng thứ hai)',
      Warehouse_Address: 'Địa chỉ kho hàng',
      Actual_Ship_Date: 'Ngày gửi hàng thực tế (ATD)',
      Customs_Brokers: 'Hải quan',
      Actual_Arrival_Date: 'Ngày đến thực tế (ATA)',
      Actual_Packing_Date: 'Ngày đóng hàng thực tế',
      Door_Point: 'Điểm giao nhận',
      Additional_Notes: 'Ghi chú bổ sung',
      Estimated_Delivery_Time: 'Thời gian giao hàng dự kiến',
      Actual_Delivery_Time: 'Thời gian giao hàng thực tế',
      PACKING: 'Đóng gói',
      PACKING_CN: 'Đóng gói (tiếng Trung)',
      PACKING_US: 'Đóng gói (tiếng Anh)',
      TYPE_OF_GOODS: 'Loại hàng hóa',
      TYPE_OF_GOODS_CODE: 'Loại hàng hóa (mã)',
      MAIN_PAYMENT_LOCATION: 'Địa điểm thanh toán vận đơn chính',
      MARK: 'Ký hiệu hàng hóa',
      HS_NUMBER: 'Mã HS',
      CUSTOM_POSITION_1: 'Vị trí tùy chỉnh 1',
      CUSTOM_POSITION_2: 'Vị trí tùy chỉnh 2',
      TRANSIT_PORT: 'Cảng trung chuyển',
      BOOKING_NUMBER: 'Số đặt chỗ',
      SHIPPING_NUMBER: 'Số hợp đồng hãng tàu',
      BARGES_REMARKS: 'Ghi chú thông tin tàu chuyển tải',
      MBL_SHIPPER: 'Người gửi hàng MB/L',
      MBL_CONSIGNEE: 'Người nhận hàng MB/L',
      MBL_NOTIFIER: 'Người thông báo MB/L'
    },
    nodeType: {
      lodingPort: 'Cảng khởi hành',
      transferPort: 'Cảng trung chuyển',
      destinationPort: 'Cảng đến',
      warehousing: 'Lưu kho',
      booking: 'Đặt chỗ',
      entrust: 'Ủy thác',
      container: 'Đóng hàng',
      distribution: 'Phân phối',
      supplement: 'Bổ sung'
    },
    // 推送渠道
    pushingChannel: {
      all: 'Tất cả',
      email: 'Email',
      msg: 'Tin nhắn'
    },
    // sop类型
    sopTypes: {
      all: 'Tất cả',
      sopSend: 'Đẩy SOP',
      innerSend: 'Đẩy nội bộ'
    },
    // 推送结果
    pushResult: {
      all: 'Tất cả',
      success: 'Thành công',
      fail: 'Thất bại'
    },
    // 系统常量
    systemConstants: {
      SE: 'Xuất khẩu đường biển',
      SI: 'Nhập khẩu đường biển',
      AE: 'Xuất khẩu đường hàng không',
      AI: 'Nhập khẩu đường hàng không',
      RE: 'Xuất khẩu đường sắt',
      RI: 'Nhập khẩu đường sắt',
      RB: 'Dịch vụ đường sắt',
      IE: 'Logistics tổng hợp',
      FBASE: 'FBA đường biển',
      FBAAE: 'FBA đường hàng không',
      FBARE: 'FBA đường sắt'
    },
    // 提单流水号类型
    BillType: {
      MBL: 'Vận đơn chính',
      HBL: 'Vận đơn phụ'
    },
    // 进口业务常量
    importConstants: {
      FCL: 'Hàng nguyên container',
      LCL: 'Hàng lẻ',
      CON: 'Gom hàng',
      POJ: 'Dự án',
      PVE: 'Hàng cá nhân',
      ECL: 'Ủy thác hàng lẻ',
      BULK: 'Hàng rời',
      CONSOLE: 'Một chính nhiều phụ',
      DIRECT: 'Vận đơn trực tiếp',
      BACK_TO_BACK: 'Một chính một phụ'
    },
    // 空运出口常量
    airExportConstants: {
      CONSOLE: 'Một chính nhiều phụ',
      DIRECT: 'Vận đơn trực tiếp',
      BACK_TO_BACK: 'Một chính một phụ'
    },
    // 海运出口常量
    seaExportConstants: {
      CONTRACT_STATE_NO: 'Chưa ký hợp đồng',
      CONTRACT_STATE_OUT_OF_DATE: 'Hợp đồng hết hiệu lực',
      CONTRACT_STATE_SIGNED: 'Đã ký hợp đồng'
    },
    templateRuleName: {
      CUSTOMER_CN_NAME: 'Tên tiếng Trung của khách hàng',
      CUSTOMER_SHORT_NAME: 'Tên viết tắt của khách hàng',
      SETTLEMENT_CN_NAME: 'Tên tiếng Trung đối tượng thanh toán',
      SETTLEMENT_SHORT_NAME: 'Tên viết tắt đối tượng thanh toán',
      BOOKING_AGENT_CN_NAME: 'Tên tiếng Trung đại lý đặt chỗ',
      BOOKING_AGENT_SHORT_NAME: 'Tên viết tắt đại lý đặt chỗ',
      LOB_NO: 'Mã nghiệp vụ',
      MBL_NO: 'MBL NO',
      HBL_NO: 'HBL NO',
      REF_NO: 'Số tờ khai hải quan',
      BILL_NO: 'Số hóa đơn',
      BILL_PAYMENT_NO: 'Số thanh toán',
      WAREHOUSE_NO: 'Số nhập kho',
      PONO: 'Mã dự án',
      CUSTOMER_REF_NO: 'Số tham chiếu nghiệp vụ',
      PLATE_NUMBER_DOOR: 'Biển số xe (điểm hiện tại)',
      PLATE_NUMBER_DEST: 'Biển số xe (điểm đến hiện tại)',
      CARRIER_CN_NAME: 'Tên tiếng Trung hãng tàu',
      CARRIER_SHORT_NAME: 'Tên viết tắt hãng tàu',
      ETD: 'Ngày khởi hành dự kiến',
      DESTINATION_PORT_CODE: 'Cảng đến',
      DESTINATION_PORT_CODE_CODE: 'Mã cảng đích'
    },
    genDocCondition: {
      FormalHbl: 'Vận đơn phụ hình thức'
    },
    buttonName: {
      FormalHbl: 'Vận đơn phụ hình thức'
    }
  },
  // 枚举参数
  parameter: {
    // 集装箱装载类型
    containerLoadType: {
      FCL: 'Hàng nguyên container',
      LCL: 'Hàng lẻ',
      BB: 'Ủy thác hàng lẻ',
      BC: 'Buyer Console',
      BULK: 'Hàng rời',
      SPA: 'Container đặc chủng'
    },
    // 合作伙伴服务项目
    partnerServiceItem: {
      ALL: 'Tất cả',
      CUSTOMER: 'Khách hàng',
      BOOKING_AGENT: 'Đại lý đặt chỗ',
      OVERSEA_AGENT: 'Đại lý cảng đích',
      DESIGNATION_AGENT: 'Đại lý hàng hóa chỉ định',
      LOCAL: 'Đại lý địa phương',
      SETTLEMENT_AGENT: 'Đại lý thanh toán',
      SEA_CMP: 'Hãng tàu',
      AIR_CMP: 'Hãng hàng không',
      SEA_CMP_AGENT: 'Đại lý tàu',
      CUSTOMS_BROKER: 'Hải quan',
      TRUCK_CMP: 'Công ty xe tải',
      WAREHOUSE: 'Kho hàng',
      GLOBAL: 'Tập đoàn',
      SHIPPER: 'Người gửi hàng',
      CONSIGNEE: 'Người nhận hàng',
      NOTIFY: 'Người thông báo',
      PORT_AGENT: 'Đại lý cửa khẩu',
      FORWARDING_AGENT: 'Đại lý vận chuyển',
      LOADINGPLACE_COMPANY: 'Công ty nơi xếp hàng',
      SIGNBILLPLACE_COMPANY: 'Công ty nơi ký vận đơn',
      DISCHARGEPORT_COMPANY: 'Công ty cảng dỡ hàng',
      DESTINATIONPORT_COMPANY: 'Công ty cảng đến',
      OTHER: 'Khác'
    },
    // 角色类型
    roleType: {
      SALES_TYPE: 'Bán hàng',
      CSR_TYPE: 'Dịch vụ khách hàng',
      DOC_TYPE: 'Chứng từ',
      OVERSEAOP_TYPE: 'Dịch vụ khách hàng hải ngoại',
      SALES_OF_GOODS: 'Bán hàng thu gom'
    }
  },
  advanceSearchForm: { // 高级查询组件
    ...viVN,
    advSearchBtn: 'Tìm kiếm nâng cao',
    quickSearch: 'Tìm kiếm nhanh',
    more: 'Thêm điều kiện',
    Equal: 'Bằng',
    Unequal: 'Không bằng',
    Greater: 'Lớn hơn',
    Less: 'Nhỏ hơn',
    Like: 'Bao gồm',
    Not_Like: 'Không bao gồm',
    Batch: 'Hàng loạt',
    BatchExclude: 'Loại trừ hàng loạt',
    Regexp: 'REGEXP',
    In: 'Bao gồm',
    Range: 'Phạm vi',
    Not_In: 'Không bao gồm',
    Is_Not_Null: 'Không trống',
    Is_Null: 'Trống',
    Is_It_Empty: 'Có trống không',
    Date_Item: 'Tùy chọn nhanh',
    customer: { // 客商
      level: 'Cấp độ khách hàng',
      chineseName: 'Tên tiếng Trung',
      status: 'Trạng thái khách hàng'
    },
    bookingNew: { // 海运订舱极速版
      destinationCountry: 'Quốc gia cảng đến',
      hblCheckingStatus: 'Trạng thái đối chiếu HBL',
      hblBlType: 'Phương thức vận đơn HBL',
      hblBillOfLadingNumber: 'Số serial vận đơn HBL',
      hblReleasingStatus: 'Trạng thái phát hành HBL',
      hblBlType2: 'Loại vận đơn HBL',
      mblCheckingStatus: 'Trạng thái đối chiếu MBL',
      mblBlType: 'Phương thức vận đơn MBL',
      mblBillOfLadingNumber: 'Số serial vận đơn MBL',
      overseaCustomerService: 'Dịch vụ khách hàng hải ngoại',
      customerLevel: 'Cấp độ khách hàng',
      isSignContract: 'Đã ký hợp đồng chưa',
      userDefinedField1: 'Trường tùy chỉnh 1',
      userDefinedField2: 'Trường tùy chỉnh 2',
      userDefinedField3: 'Trường tùy chỉnh 3',
      opOffice: 'Chi nhánh vận hành',
      salesOffice: 'Chi nhánh bán hàng',
      bookingAgentIsNull: 'Đại lý đặt chỗ trống'
    },
    shortcut: 'Tùy chọn nhanh',
    daterange: 'Phạm vi',
    lt: 'Nhỏ hơn',
    gt: 'Lớn hơn',
    eq: 'Bằng',
    notEq: 'Không bằng',
    like: 'Bao gồm',
    draft: 'Bản nháp',
    commit: 'Gửi',
    check: 'Duyệt',
    createDate: 'Ngày tạo',
    nowWeek: 'Tuần này',
    preWeek: 'Tuần trước',
    nextWeek: 'Tuần sau',
    nowMonth: 'Tháng này',
    preMonth: 'Tháng trước',
    nextMonth: 'Tháng sau',
    doubleClickToSelect: 'Nhấn đúp vào hộp văn bản để chọn trạng thái nút truy vấn',
    fitAll: 'Thỏa mãn tất cả điều kiện sau',
    fitAny: 'Thỏa mãn bất kỳ điều kiện nào sau đây'
  },
  route: {
    dashboard: 'Trang chủ',
    baseInfo: 'Tài liệu cơ bản',
    seaport: 'Cảng biển',
    airport: 'Cảng hàng không',
    airlineCode: 'Mã hãng hàng không',
    operationRequirementDescribe: 'Mô tả yêu cầu thao tác',
    city: 'Thành phố',
    basicData: 'Dữ liệu cơ bản',
    customsCommodityCode: 'Mã hàng hóa hải quan',
    usCommodityCode: 'Mã hàng hóa Hoa Kỳ',
    country: 'Quốc gia',
    rateManagement: 'Quản lý tỷ giá',
    chargeService: 'Hạng mục thu phí',
    costPlan: 'Phương án chi phí',
    guarantee: 'Thư bảo lãnh',
    payService: 'Hạng mục thu phí',
    partner: 'Đối tác',
    mailingAddress: 'Địa chỉ giao nhận',
    seaPortRequirement: 'Yêu cầu cảng (cảng biển)',
    airPortRequirement: 'Yêu cầu cảng (cảng hàng không)',
    partnerInformationImport: 'Nhập thông tin đối tác',
    seaExport: 'Xuất khẩu đường biển',
    bookingNew: 'Phiên bản đặt chỗ đường biển tốc độ cao',
    ProjectManage: 'Quản lý dự án',
    project: 'Dự án',
    order: 'Quản lý đơn hàng',
    warehousing: 'Quản lý nhập kho',
    inventory: 'Quản lý kho hàng',
    seaImport: 'Nhập khẩu đường biển',
    airExport: 'Xuất khẩu đường hàng không',
    seaImportBooking: 'Thao tác đường biển',
    airExportBooking: 'Đặt chỗ đường hàng không',
    airImportBooking: 'Thao tác đường hàng không',
    railwayExport: 'Xuất khẩu đường sắt',
    integratedJob: 'Logistics tổng hợp',
    remoteBooking: 'Đặt chỗ từ xa',
    prediction: 'Dự báo',
    preBooking: 'Kiểm duyệt trước khi đặt chỗ',
    preOrder: 'Kiểm tra trước đơn hàng'
  },
  navbar: {
    screenfull: 'Toàn màn hình',
    logOut: 'Đăng xuất',
    dashboard: 'Trang chủ',
    github: 'Địa chỉ dự án',
    theme: 'Đổi giao diện',
    size: 'Kích thước bố cục'
  },
  login: {
    title: 'Đăng nhập hệ thống',
    logIn: 'Đăng nhập',
    username: 'Tài khoản',
    password: 'Mật khẩu'
  },
  act: {
    billing: {
      pleaseSelectBilling: 'Vui lòng chọn hóa đơn!',
      hasConfirmed: 'Hóa đơn 【{0}】 đã được xác nhận!',
      hasReviewed: 'Hóa đơn 【{0}】 đã được kiểm tra lại!',
      hasBillingGroup: 'Hóa đơn 【{0}】 đã được đối chiếu!',
      hasInvoice: 'Hóa đơn 【{0}】 đã được xuất!',
      hasWriteOff: 'Hóa đơn 【{0}】 đã được hủy!',
      confirmDelete: 'Xác nhận xóa {0} hóa đơn này?',
      noConfirmBill: 'Không có hóa đơn nào để xác nhận!',
      noRecheckBill: 'Không có hóa đơn nào để kiểm tra lại!',
      noCancelRecheckBill: 'Không có hóa đơn nào để hủy xác nhận!',
      batchConfirmBill: 'Xác nhận xác nhận hàng loạt {0} hóa đơn này?',
      batchRecheckBill: 'Xác nhận kiểm tra lại hàng loạt {0} hóa đơn này?',
      noCancelConfirmBill: 'Không có hóa đơn nào để hủy xác nhận!',
      confirmCancelBill: 'Xác nhận hủy xác nhận {0} hóa đơn này?',
      cancelRecheckBill: 'Xác nhận hủy kiểm tra lại {0} hóa đơn này?',
      sameSettlementAgent: 'Đại lý thanh toán của hóa đơn phải giống nhau!',
      hasBillingGroupNo: 'Đã tạo số đối chiếu',
      noBillToBillingGroup: 'Không có hóa đơn nào để đối chiếu',
      confirmSuccess: 'Xác nhận thành công!',
      recheckSuccess: 'Kiểm tra lại thành công!',
      cancelConfirmSuccess: 'Hủy xác nhận thành công',
      cancelRecheckSuccess: 'Hủy kiểm tra lại thành công!',
      reconciliationAmountNotSupport: 'Số tiền đối chiếu bạn nhập không hợp lý!',
      overseaHasPushed: '【{0}】Hóa đơn đã được gửi, không thể xóa.',
      advDeleteConfirmTitle: 'Hóa đơn thu hộ tạm ứng đã được đẩy lên Kingdee, vui lòng đảm bảo đơn tương ứng đã được xóa trên Kingdee trước khi xóa.'
    },
    billingGroup: {
      hasConfirmed: 'Đối chiếu 【{0}】 đã được xác nhận!',
      hasReviewed: 'Đối chiếu 【{0}】 đã được kiểm tra lại!',
      confirmDelete: 'Xác nhận xóa {0} đối chiếu này?',
      billingNotNull: 'Hóa đơn không được để trống!',
      canNotRemoveAllBills: 'Không thể xóa toàn bộ hóa đơn!',
      settlementAgentNotNull: 'Đại lý thanh toán của hóa đơn 【{0}】 không được để trống!',
      settlementAgentAndAccountCanNotSame: 'Đại lý thanh toán của hóa đơn 【{0}】 không khớp với đối tượng thanh toán của đối chiếu, vui lòng xóa hóa đơn này trước khi lưu!',
      validateAp: 'Khi loại thu chi là phải thu, tổng số tiền hóa đơn phải thu không được nhỏ hơn tổng số tiền hóa đơn phải trả!',
      validateAr: 'Khi loại thu chi là phải trả, tổng số tiền hóa đơn phải trả không được nhỏ hơn tổng số tiền hóa đơn phải thu!',
      selectedBillingGroup: 'Vui lòng chọn đối chiếu!',
      batchConfirmBillGroup: 'Xác nhận xác nhận hàng loạt {0} đối chiếu này?',
      batchConfirmBill: 'Cập nhật trạng thái hóa đơn thành đã xác nhận?',
      noRecheckBillGroup: 'Không có đối chiếu nào để kiểm tra lại!',
      batchRecheckBillGroup: 'Xác nhận kiểm tra lại {0} đối chiếu này?',
      batchCancelRecheckBillGroup: 'Xác nhận hủy kiểm tra lại {0} đối chiếu này?',
      noCancelRecheckBillGroup: 'Không có đối chiếu nào để hủy kiểm tra lại!',
      noCancelConfirmBillGroup: 'Bảng đối chiếu đã được kiểm tra, không thể hủy xác nhận!'
    }
  },
  grid: {
    resetSort: 'Đặt lại sắp xếp',
    restColumns: 'Đặt lại cột',
    autoSizeColumns: 'Tự động điều chỉnh tất cả các cột',
    pinLeftAll: 'Khóa tất cả các cột bên trái',
    subtotal: 'Tổng phụ',
    groupedSubtotal: 'Đếm từng mục',
    summaryMode: 'Phương thức tổng hợp thống kê',
    count: 'Đếm',
    sum: 'Tính tổng'
  }
}

// agGrid表格
export const i18n_ag_grid = {
  // for filter panel
  page: 'Trang',
  more: 'Thêm',
  to: '-',
  of: 'Đến',
  next: 'Trang tiếp',
  last: 'Trang trước',
  first: 'Trang đầu',
  previous: 'previous',
  loadingOoo: 'Đang tải...',

  // for set filter
  selectAll: 'Chọn tất cả',
  searchOoo: 'Tìm kiếm...',
  blanks: 'Trống',

  // for number filter and text filter
  filterOoo: 'Lọc...',
  applyFilter: 'Áp dụng bộ lọc...',

  // for number filter
  equals: 'Bằng',
  lessThan: 'Nhỏ hơn',
  greaterThan: 'Lớn hơn',

  // for text filter
  contains: 'Bao gồm',
  startsWith: 'Từ đầu',
  endsWith: 'Kết thúc',

  // the header of the default group column
  group: 'Nhóm dữ liệu',

  // tool panel
  columns: 'Thiết lập cột',
  filters: 'Bộ lọc',
  rowGroupColumns: 'Cột nhóm hàng',
  rowGroupColumnsEmptyMessage: 'Kéo tên cột vào đây để nhóm dữ liệu (trang hiện tại)',
  valueColumns: 'Cột giá trị',
  pivotMode: 'Chế độ trục',
  groups: 'Nhóm dữ liệu',
  values: 'Giá trị',
  pivots: 'Trục',
  valueColumnsEmptyMessage: 'Thông báo trống cột giá trị',
  pivotColumnsEmptyMessage: 'Thông báo trống cột trục',
  toolPanelButton: 'Nút bảng điều khiển',

  // other
  noRowsToShow: 'Không có kết quả tìm kiếm',

  // enterprise menu
  pinColumn: 'Khóa cột',
  valueAggregation: 'Tập hợp giá trị',
  autosizeThiscolumn: 'Tự động điều chỉnh cột',
  autosizeAllColumns: 'Tự động điều chỉnh tất cả các cột',
  groupBy: 'Nhóm',
  ungroupBy: 'Không nhóm',
  resetColumns: 'Đặt lại',
  expandAll: 'Mở rộng',
  collapseAll: 'Thu gọn',
  toolPanel: 'Bảng công cụ',
  'export': 'Xuất',
  csvExport: 'CSV ',
  excelExport: 'Excel ',

  // enterprise menu pinning
  pinLeft: 'Khóa bên trái',
  pinRight: 'Khóa bên phải',
  noPin: 'Không khóa <>',

  // enterprise menu aggregation and status panel
  sum: 'Và',
  min: 'Tối thiểu',
  max: 'Tối đa',
  none: 'Không có',
  count: 'Đếm',
  average: 'Giá trị trung bình',

  // standard menu
  copy: 'Sao chép',
  copyWithHeaders: 'Sao chép bao gồm tiêu đề',
  ctrlC: 'ctrl + C',
  paste: 'Dán',
  ctrlV: 'ctrl + V',

  // Set Filter
  selectAllSearchResults: '(Chọn tất cả kết quả tìm kiếm)',
  noMatches: 'Không có kết quả phù hợp',

  // Number Filter & Text Filter
  notEqual: 'Không bằng',
  empty: 'Vui lòng chọn',

  // Number Filter
  lessThanOrEqual: 'Nhỏ hơn hoặc bằng',
  greaterThanOrEqual: 'Lớn hơn hoặc bằng',
  inRange: 'Phạm vi',
  inRangeStart: 'Đến',
  inRangeEnd: 'Từ',

  // Text Filter
  notContains: 'Không bao gồm',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',

  // Filter Conditions
  andCondition: 'Và',
  orCondition: 'Hoặc',

  // Filter Buttons
  resetFilter: 'Đặt lại',
  clearFilter: 'Xóa',
  cancelFilter: 'Hủy',

  // Filter Titles
  textFilter: 'Bộ lọc văn bản',
  numberFilter: 'Bộ lọc số',
  dateFilter: 'Bộ lọc ngày',
  setFilter: 'Bộ lọc tập hợp',

  // Other
  enabled: 'Kích hoạt',
  // Enterprise Menu Aggregation and Status Bar
  avg: 'Trung bình',
  filteredRows: 'Đã lọc',
  selectedRows: 'Đã chọn',
  totalRows: 'Tổng số dòng',
  totalAndFilteredRows: 'Số dòng',
  nextPage: 'Trang tiếp',
  lastPage: 'Trang cuối',
  firstPage: 'Trang đầu',
  previousPage: 'Trang trước',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Biểu đồ và chế độ xem phối cảnh',
  pivotChart: 'Biểu đồ phối cảnh',
  chartRange: 'Phạm vi biểu đồ',

  columnChart: 'Biểu đồ cột',
  groupedColumn: 'Đã nhóm',
  stackedColumn: 'Đã xếp chồng',
  normalizedColumn: '100% xếp chồng',

  barChart: 'Biểu đồ thanh',
  groupedBar: 'Đã nhóm',
  stackedBar: 'Đã xếp chồng',
  normalizedBar: '100% xếp chồng',

  pieChart: 'Biểu đồ tròn',
  pie: 'Hình tròn',
  doughnut: 'Biểu đồ vành khuyên',

  line: 'Line',

  xyChart: 'X Y (biểu đồ phân tán)',
  scatter: 'Phân tán',
  bubble: 'Bong bóng',

  areaChart: 'Biểu đồ miền',
  area: 'Diện tích',
  stackedArea: 'Đã xếp chồng',
  normalizedArea: '100% xếp chồng',

  histogramChart: 'Biểu đồ tần suất',

  // Charts
  pivotChartTitle: 'Biểu đồ Pivot',
  rangeChartTitle: 'Biểu đồ phạm vi',
  settings: 'Cài đặt',
  data: 'Dữ liệu',
  format: 'Định dạng',
  categories: 'Danh mục',
  defaultCategory: '(Không)',
  series: 'Chuỗi',
  xyValues: 'Giá trị X Y',
  paired: 'Chế độ ghép đôi',
  axis: 'Trục',
  navigator: 'Trình hướng dẫn',
  color: 'Màu sắc',
  thickness: 'Độ dày',
  xType: 'Loại X',
  automatic: 'Tự động',
  category: 'Danh mục',
  number: 'Số',
  time: 'Thời gian',
  xRotation: 'Xoay X',
  yRotation: 'Xoay Y',
  ticks: 'Thang đo',
  width: 'Độ rộng',
  height: 'Chiều cao',
  length: 'Độ dài',
  padding: 'Tô màu',
  spacing: 'Khoảng cách',
  chart: 'Biểu tượng',
  title: 'Tiêu đề',
  titlePlaceholder: 'Tiêu đề biểu đồ - Nhấp đúp để chỉnh sửa',
  background: 'Nền',
  font: 'Phông chữ',
  top: 'Trên cùng',
  right: 'Phải',
  bottom: 'Đáy',
  left: 'Trái',
  labels: 'Nhãn',
  size: 'Kích thước',
  minSize: 'Kích thước tối thiểu',
  maxSize: 'Kích thước tối đa',
  legend: 'Mô tả',
  position: 'Vị trí',
  markerSize: 'Kích thước đánh dấu',
  markerStroke: 'Nét đánh dấu',
  markerPadding: 'Tô màu đánh dấu',
  itemSpacing: 'Khoảng cách trường',
  itemPaddingX: 'Đệm trường X',
  itemPaddingY: 'Đệm trường Y',
  layoutHorizontalSpacing: 'Khoảng cách ngang',
  layoutVerticalSpacing: 'Khoảng cách dọc',
  strokeWidth: 'Độ rộng nét',
  offset: 'Độ lệch',
  offsets: 'Lượng lệch',
  tooltips: 'Nhắc nhở',
  callout: 'Chú thích',
  markers: 'Đánh dấu',
  shadow: 'Đổ bóng',
  blur: 'Làm mờ',
  xOffset: 'Độ lệch X',
  yOffset: 'Độ lệch Y',
  lineWidth: 'Độ rộng đường',
  normal: 'Bình thường',
  bold: 'Đậm',
  italic: 'Nghiêng',
  boldItalic: 'Đậm nghiêng',
  predefined: 'Định nghĩa trước',
  fillOpacity: 'Độ mờ tô màu',
  strokeOpacity: 'Độ mờ đường',
  histogramBinCount: 'Số lượng Bin',
  columnGroup: 'Biểu đồ cột',
  barGroup: 'Biểu đồ thanh',
  pieGroup: 'Biểu đồ tròn',
  lineGroup: 'Biểu đồ đường',
  scatterGroup: 'X Y (biểu đồ phân tán)',
  areaGroup: 'Biểu đồ miền',
  histogramGroup: 'Biểu đồ tần suất',
  groupedColumnTooltip: 'Đã nhóm',
  stackedColumnTooltip: 'Đã xếp chồng',
  normalizedColumnTooltip: '100% xếp chồng',
  groupedBarTooltip: 'Đã nhóm',
  stackedBarTooltip: 'Đã xếp chồng',
  normalizedBarTooltip: '100% xếp chồng',
  pieTooltip: 'Biểu đồ tròn',
  doughnutTooltip: 'Biểu đồ vành khuyên',
  lineTooltip: 'Biểu đồ đường',
  groupedAreaTooltip: 'Đã nhóm',
  stackedAreaTooltip: 'Đã xếp chồng',
  normalizedAreaTooltip: '100% xếp chồng',
  scatterTooltip: 'Biểu đồ phân tán',
  bubbleTooltip: 'Biểu đồ bong bóng',
  histogramTooltip: 'Biểu đồ tần suất',
  noDataToChart: 'Không có dữ liệu để vẽ.',
  pivotChartRequiresPivotMode: 'Biểu đồ Pivot cần đảm bảo chế độ Pivot đã được bật.',
  chartSettingsToolbarTooltip: 'Menu',
  chartLinkToolbarTooltip: 'Liên kết đến biểu đồ',
  chartUnlinkToolbarTooltip: 'Hủy liên kết với biểu đồ',
  chartDownloadToolbarTooltip: 'Tải xuống biểu đồ',

  // ARIA
  ariaHidden: 'Ẩn',
  ariaVisible: 'Hiển thị',
  ariaChecked: 'Đã chọn',
  ariaUnchecked: 'Chưa chọn',
  ariaIndeterminate: 'Không xác định',
  ariaColumnSelectAll: 'Chuyển đổi chọn tất cả cột',
  ariaInputEditor: 'Trình chỉnh sửa nhập liệu',
  ariaDateFilterInput: 'Lọc theo ngày',
  ariaFilterInput: 'Nhập bộ lọc',
  ariaFilterColumnsInput: 'Nhập cột lọc',
  ariaFilterValue: 'Giá trị lọc',
  ariaFilterFromValue: 'Lọc từ giá trị',
  ariaFilterToValue: 'Lọc đến giá trị',
  ariaFilteringOperator: 'Toán tử lọc',
  ariaColumnToggleVisibility: 'Chuyển đổi hiển thị cột',
  ariaColumnGroupToggleVisibility: 'Chuyển đổi hiển thị nhóm cột',
  ariaRowSelect: 'Nhấn phím cách để chọn hàng này',
  ariaRowDeselect: 'Nhấn phím cách để bỏ chọn hàng này',
  ariaRowToggleSelection: 'Nhấn phím cách để chuyển đổi chọn hàng',
  ariaRowSelectAll: 'Nhấn phím cách để chuyển đổi chọn tất cả hàng',
  ariaSearch: 'Tìm kiếm',
  ariaSearchFilterValues: 'Tìm kiếm giá trị lọc'
}
